/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter detections by category class
 * @export
 */
export const ControlCategoryClass2 = {
    Endpoint: 'ENDPOINT',
    Identity: 'IDENTITY',
    Cloud: 'CLOUD',
    Email: 'EMAIL',
    Network: 'NETWORK',
    Data: 'DATA',
    Posture: 'POSTURE',
    Other: 'OTHER'
} as const;
export type ControlCategoryClass2 = typeof ControlCategoryClass2[keyof typeof ControlCategoryClass2];


export function ControlCategoryClass2FromJSON(json: any): ControlCategoryClass2 {
    return ControlCategoryClass2FromJSONTyped(json, false);
}

export function ControlCategoryClass2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCategoryClass2 {
    return json as ControlCategoryClass2;
}

export function ControlCategoryClass2ToJSON(value?: ControlCategoryClass2 | null): any {
    return value as any;
}

